import { render, staticRenderFns } from "./TireProductCard.vue?vue&type=template&id=2ad4f521"
import script from "./TireProductCard.vue?vue&type=script&lang=ts"
export * from "./TireProductCard.vue?vue&type=script&lang=ts"
import style0 from "./TireProductCard.vue?vue&type=style&index=0&id=2ad4f521&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports